import { createSwiper } from '../adapters/SwiperAdapter';

export const perksSectionOnLoadHandler = () => {
    createSwiper('.perks .swiper', {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
            el: '.perks-pagination',
        },
        breakpoints: {
            758: {
                slidesPerView: 3,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });
};